import { BButton, BModal } from "components/base";
import { useCallback } from "react";
import "./DeleteConversationModal.scss";

type DeleteConversationModalProps = {
  open: boolean;
  conversationName: string;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const DeleteConversationModal = ({
  open,
  conversationName,
  loading = false,
  onCancel,
  onConfirm,
}: DeleteConversationModalProps) => {
  const handleCancel = useCallback(() => {
    if (loading) {
      return;
    }
    onCancel();
  }, [loading, onCancel]);

  const handleConfirm = useCallback(() => {
    if (loading) {
      return;
    }
    onConfirm();
  }, [loading, onConfirm]);

  return (
    <BModal
      open={open}
      title="Xóa cuộc trò chuyện?"
      onCancel={handleCancel}
      footer={null}
      width={420}
      destroyOnClose
      className="delete-conversation-modal"
      maskClosable={!loading}
      closable={!loading}
    >
      <p className="delete-conversation-modal__message">
        Thao tác này sẽ xóa <strong>{conversationName}</strong>.
      </p>

      <div className="delete-conversation-modal__actions">
        <BButton className="delete-conversation-modal__cancel" onClick={handleCancel} disabled={loading}>
          Hủy
        </BButton>
        <BButton
          className="delete-conversation-modal__confirm"
          type="primary"
          danger
          loading={loading}
          onClick={handleConfirm}
        >
          Xóa
        </BButton>
      </div>
    </BModal>
  );
};

export default DeleteConversationModal;
